import React from 'react';
import styled from '@emotion/styled';
import SVG from '@app/components/SVG';
import Loadable from '@app/utils/Loadable';
import { TabIndicator } from '@mortee/components/ProgressTabs';
import { SupplierValidationDocument } from '@mortee/domain/validationSystem';
import AutomailerEmailCountIcon from '@mortee/images/validationSystem/indicators/automailer/email-count.svg';

export function renderDocumentsTabIndicator(documents: Loadable<SupplierValidationDocument[]>): TabIndicator | null {
  if (!documents.isResolved()) {
    return null;
  }

  const documentsAmount = documents.result.length;

  if (documentsAmount === 0) {
    return {
      text: 'No documents',
      icon: null,
    };
  }

  return {
    text: 'Number of documents = ' + documentsAmount,
    icon: (
      <CountWrapper>
        <SVG
          width={22}
          height={22}
          image={AutomailerEmailCountIcon}
          accessibilityLabel={`Documents Count Of ${documentsAmount}`}
        />
        <div>{documentsAmount}</div>
      </CountWrapper>
    ),
  };
}

export const CountWrapper = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  font-size: 13px;

  & > * {
    grid-row: 1;
    grid-column: 1;
  }
`;
